import { roadC1 } from "../utils/roadC1";
import RoadMapGeneric from "../components/Roadmaps/RoadMapGeneric";

const RoadMapC1 = (props) => <RoadMapGeneric {...props} roadData={roadC1} />;
export default RoadMapC1;